import { motion } from "framer-motion";
import {
  ArrowTrendingUpIcon,
  BriefcaseIcon,
  RocketLaunchIcon,
} from "@heroicons/react/24/outline";

export default function SecondSectionCapital() {
  return (
    <section className="px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="max-w-6xl mx-auto text-center"
      >
        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
            LoopHole <span className="text-[#92abc4]">Capital</span>
          </h2>
        <h5 className="text-3xl md:text-4xl font-bold tracking-tight">
          We help <span className="text-amber-500">founders</span> make something <br />
          people want — and the <span className="text-amber-500">results</span> <br />
          speak for themselves.
        </h5>

        {/* Description */}
        <p className="mt-6 max-w-2xl mx-auto text-gray-500 text-sm md:text-base leading-relaxed">
          NextLoop Capital empowers founders and investors to bring ideas that truly matter to life. From early traction to long-term scale, we provide the expertise, capital, and connections to turn vision into reality. Beyond startup support, we open doors to global investment opportunities from New Zealand real estate to diverse offshore markets, giving our partners access to high-potential ventures and assets. At NextLoop Capital, we don’t just invest; we make things happen.
        </p>

        {/* Grid */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Card 1 */}
          <div className="border rounded-xl p-8 text-left">
            <ArrowTrendingUpIcon className="w-8 h-8 text-emerald-600" />
            <h3 className="mt-4 font-semibold text-gray-900">
              Higher Success Rate
            </h3>
            <p className="mt-2 text-sm text-gray-600">
              We improve the success rate of our startups through strategy,
              mentorship, and capital access.
            </p>
          </div>

          {/* Card 2 */}
          <div className="border rounded-xl p-8 text-left">
            <BriefcaseIcon className="w-8 h-8 text-indigo-600" />
            <h3 className="mt-4 font-semibold text-gray-900">
              Fundraising Advantage
            </h3>
            <p className="mt-2 text-sm text-gray-600">
              We give startups a strong edge when raising capital through our
              investor network.
            </p>
          </div>

          {/* Card 3 */}
          <div className="border rounded-xl p-8 text-left">
            <RocketLaunchIcon className="w-8 h-8 text-orange-500" />
            <h3 className="mt-4 font-semibold text-gray-900">
              Early-Stage Focus
            </h3>
            <p className="mt-2 text-sm text-gray-600">
              We work closely with founders at their earliest stages to shape
              strong foundations.
            </p>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
